import { css } from '@linaria/core';
import { Button } from 'components/Button';
import { IconProps } from 'components/Icons/IconProps';
import { baseTheme } from 'styles/utils';

// Interface for component props
interface ComputeCardProps {
  id: string;
  title: string;
  text: string;
  icon?: React.FC<IconProps>;
  badge?: string;
  cta: {
    label: string;
    action: () => void;
  };
  style?: React.CSSProperties;
}
const CalloutCard = ({
  id,
  title,
  text,
  cta,
  icon,
  badge,
  style
}: ComputeCardProps) => {
  const IconComponent = (icon as React.FC<IconProps>);
  return <div key={id} className={calloutCardStyles.container} style={style}>
      <div className={calloutCardStyles.header}>
        <div className={calloutCardStyles.icon}>{IconComponent && <IconComponent color="white" size={24} />}</div>
        {badge && <div className={calloutCardStyles.badge}>{badge}</div>}
      </div>
      <div className={calloutCardStyles.content}>
        <p className={calloutCardStyles.title}>{title}</p>
        <p className={calloutCardStyles.text}>{text}</p>
      </div>
      <div className={calloutCardStyles.footer}>
        <Button variant="tertiary" className="cta-button" size="md" onClick={cta?.action} role="button" tabIndex={0}>
          {cta.label}
        </Button>
      </div>
    </div>;
};
const calloutCardStyles = {
  container: "odules__Compute__Components__CalloutCard__CalloutCard_tsx-container-c1ae5m6c",
  header: "odules__Compute__Components__CalloutCard__CalloutCard_tsx-header-h52k9mj",
  icon: "odules__Compute__Components__CalloutCard__CalloutCard_tsx-icon-i5eb7n8",
  badge: "odules__Compute__Components__CalloutCard__CalloutCard_tsx-badge-b69twi2",
  content: "odules__Compute__Components__CalloutCard__CalloutCard_tsx-content-c1wwovi7",
  title: "odules__Compute__Components__CalloutCard__CalloutCard_tsx-title-t1e5qbhc",
  text: "odules__Compute__Components__CalloutCard__CalloutCard_tsx-text-t19u6ph0",
  footer: "odules__Compute__Components__CalloutCard__CalloutCard_tsx-footer-f2bg8nx"
};
export default CalloutCard;

require("./CalloutCard.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./CalloutCard.tsx");